import classes from "./SeoList.module.scss";
import RedTitle from '../RedTitle/RedTitle';
import Item from '../Item/Item';
import Tooltip from '../../../Tooltip/tooltip';
import BoldTitle from '../../../Titles/BoldTitle/BoldTitle';
import Image from '../../../Image/Image';

import fMonth from "../../../Assets/Img/Src/fMonth.png"
import fMonthWebp from "../../../Assets/Img/Webp/fMonth.webp"


import search from "../../../Assets/Img/Src/search.png"
import searchWebp from "../../../Assets/Img/Webp/search.webp"
import Cards from "../../../Cards/Cards";


const SeoList = () => {
  return (
    <div className={classes.SeoList}>
      <RedTitle
        number={"03."}
        title={"SEO"}
        customClass={classes.Title}
      />
      <div className={classes.ScrollWrap}>
        <Item
          customWrapClass={classes.ItemWrap}
          number={"a."}
          title={"Внутренняя  поисковая оптимизация."}
          text={<><span>Проведена оптимизация сайта по чек-листу, содержащему порядка 40 основных пунктов. <Tooltip customClass={classes.Tooltip} text="Чек-лист оптимизации, как и все таблицы c KPI, а также отчетность были разработана под данный проект, учитывая его задачи и особенности." />       Собраны рекомендации Яндекса и Google технического характера, которые были внедрены специалистами нашей поддержки.</span> <br /><span>Все работы по SEO-оптимизации и последующие работы по поисковому продвижению были  регламентированы и  систематизированы, что позволило четко планировать загрузку специалистов, а также повысило прозрачность оказания услуг для Заказчика.</span></>}
          src={fMonth} srcWebp={fMonthWebp}
          customClass={classes.Cards}
          
          customTitleClass={classes.CardsTitle}
          customClassText={classes.CustomText}

        />
      </div>
      <div className={classes.Wrapper} >
        <BoldTitle
          text={<><span>Результатом внутренней поисковой оптимизации стал рост<br /> количества страниц в индексе поисковых систем в </span>5 раз <span> <br />Количество запросов, находящихся в ТОП 10 увеличилось </span>на 300%</>}
          customClass={classes.Boldtitle}
        />
        <div className={classes.Img}>
        <Image src={search} srcWebp={searchWebp} />
        </div>
      </div>
      <div className={classes.ItemText}>
        <div className={classes.Item}>
          <Cards
            number={"b."}
            title={"Формирование гипотез по развитию сайта\n на основе аналитики."}
            customClass={classes.Cards}

            customTitleClass={classes.CardsTitle}
            customClassText={classes.CustomText}
          />
          <div className={classes.RightSide}>
            <p className={classes.Text}>На основе    анализа статистических данных мы постоянно тестировали и внедряли новую функциональность на сайте, расширяя воронку продаж. Самый большой, сложный и эффективный пункт в данной работе – это создание ЧПУ&nbsp;-&nbsp;фильтра в каталоге продукции. Данное внедрение позволило расширить количество страниц в поиске до 45 000! Каталог был не просто модернизирован. Для всех новых страниц ЧПУ-фильтра  была создана архитектура формирования мета-описаний и тега H1, а также генерация сложнейшей карты сайта sitemap.xml, благодаря которой страницы были загружены в индекс.</p>
            <p className={classes.Text}>Для того чтобы охватить работы по всем этим направлениям и четко соблюдать дедлайны, мы подключили сотрудников Заказчика к <span className={classes.TooltipWrap}>CRM Bitrix24<Tooltip customClassToltip={classes.CustomTooltip} customClass={classes.TooltipSm} text={"Система управления проектами"}/></span>. Кроме этого мы разработали таблицы с ежемесячными планами, статусами по работам и контролем основных KPI. Мы отслеживали все: от перехода пользователя на сайт до стоимости конкретной покупки.</p>
          </div>
        </div>
          <div className={classes.Item}>
            <Cards
              number={"с."}
              title={"Внешняя\n поисковая\n оптимизация."}
              customClass={classes.Cards}

              customTitleClass={classes.CardsTitle}
              customClassText={classes.CustomText}
            />
            <div className={classes.RightSide}>
              <p className={classes.Text}>Были настроены Вебмастера Яндекса, Google, Mail, Bing <Tooltip customClassToltip={classes.CustomTooltip} customClass={classes.Tooltip} text={"Данные сервисы постоянно отслеживают основные параметры сайта. Некоторые данные можно получить только из них, например количество страниц в индексе поисковых систем или количество учитываемых ссылок на сайт."}/>    . На основе этих данных были проведены работы по улучшению ранжирования страниц сайта.</p>
              <p className={classes.Text}>Кроме этого работы по внешней оптимизации включали в себя построение ссылочного профиля сайта, а также создание и реализацию стратегии развития ссылочной массы.</p>
            </div>
          </div>
      </div>
    </div>

  )
}

export default SeoList;